import $ from 'jquery';

export const animations = {
  updateFadeIns(container) {
        // Set the breakpoint at which elements fade in (as a percentage of window height)
    const breakpoint = $(container).height() / 6;

        // Find current window position
    const bottom_of_window = $(container).scrollTop() + $(container).height();

        // For each element with the fade in class...
    $('.fade-in-on-scroll').each((i, el) => {
      const element_top = $(el).offset().top;

            // If the element is within fade-in range, mark it visible; otherwise, remove the visible class
      if (element_top + breakpoint <= bottom_of_window) {
        $(el).addClass('visible');
      } else {
        $(el).removeClass('visible');
      }
    });
  },

  attachAccordionListeners() {
        // NUTRITION FACTS CARD ANIMATIONS
        // Enables the expand and collapse buttons on the nutrition facts card in the PDP

        // When the hader of a nutrition facts section is clicked...
    $(document).on('click', '.nutrition-facts-section-header', function() {

            // Grab the ID of the section from the clicked header's data attributes
      const id = $(this).data('section-id');

            // If the clicked section is visible, hide it
      if ($(`.nutrition-facts-section-body[data-section-id=${id}]`).is(':visible()')) {
        $(`.nutrition-facts-section-body[data-section-id=${id}]`).slideUp();
        $(`.nutrition-facts-section-header[data-section-id=${id}] .nav-tool`).html('+');

            // If the clicked section is visible, show it, and hide all other sections
      } else {
        $(`.nutrition-facts-section-body[data-section-id=${id}]`).slideDown();
        $(`.nutrition-facts-section-header[data-section-id=${id}] .nav-tool`).html('-');

        $(`.nutrition-facts-section-body[data-section-id!=${id}]`).slideUp();
        $(`.nutrition-facts-section-header[data-section-id!=${id}] .nav-tool`).html('+');
      }
    });
  },
};
